import { useRef } from "react";
import { IonContent, IonModal, IonPage } from "@ionic/react";
import { useSchools } from "components/FormFields";
import RequestForm from "components/RequestForm/RequestForm";
import { RequestModel } from "model";

import { Loader } from "~components/Atoms";

export type EditStatus = "Success" | "Cancelled";

type EditRequestModalProps = {
  request: RequestModel;
  onClose: (status: EditStatus) => void;
};

export function EditRequestModal(props: EditRequestModalProps) {
  const { request, onClose } = props;

  /*** Hooks ***/
  const modal = useRef<HTMLIonModalElement>(null);

  /*** Queries ***/
  const schools = useSchools();

  /*** Render ***/
  return (
    <IonModal ref={modal} isOpen={true} onDidDismiss={() => onClose("Cancelled")}>
      <IonPage>
        <IonContent>
          {!schools && <Loader />}
          {schools && (
            <RequestForm
              mode="edit"
              request={request}
              schools={schools}
              onModalDismiss={() => onClose("Cancelled")}
              onModalSuccess={() => onClose("Success")}
            />
          )}
        </IonContent>
      </IonPage>
    </IonModal>
  );
}
